var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "jsoneditor-vue" }),
    _vm._v(" "),
    _vm.showBtns !== false
      ? _c("div", { staticClass: "jsoneditor-btns" }, [
          _c(
            "button",
            {
              staticClass: "json-save-btn",
              attrs: { type: "button", disabled: _vm.error },
              on: {
                click: function ($event) {
                  return _vm.onSave()
                },
              },
            },
            [_vm._v(_vm._s(_vm.locale[_vm.lang].save))]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }